import { Grid, Typography } from '@mui/material';

import MilestonesPropTypes from '../../proptypes/milestones';
import StatsPropTypes from '../../proptypes/stats';
import { convertStatsData } from '../../services/computation/convertStatsData';
import MetricChart from './MetricChart';

const ContainerStats = ({ stats, statsReference, milestones }) => {
    const statsData = convertStatsData(stats);

    const statsReferenceData = statsReference ? convertStatsData(statsReference) : {};

    return (
        <Grid container>
            <Grid item xs={12} md={6}>
                <Typography variant="h4">CPU</Typography>
                <MetricChart
                    title="CPU consumption"
                    metric="CPU"
                    unit="ms"
                    yDatasets={[statsData.cpu, statsReferenceData.cpu]}
                    milestones={milestones}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography variant="h4">Network</Typography>
                <MetricChart
                    title="Network I/O"
                    metric="Network"
                    unit="MB"
                    yDatasets={[statsData.network, statsReferenceData.network]}
                    milestones={milestones}
                />
            </Grid>
        </Grid>
    );
};

ContainerStats.propTypes = {
    stats: StatsPropTypes,
    statsReference: StatsPropTypes,
    statsReferenceData: StatsPropTypes,
    milestones: MilestonesPropTypes,
};

export default ContainerStats;
